import {useQuery} from 'react-query';

import getSubInputLists from '.';

const useGetSubInputLists = (props: ISubInputListProps) => {

  const {data, isLoading} = useQuery(
    ['get-input-lists', props],
    () => getSubInputLists(props),
    {enabled: !!props.input},
  );

  return {data, isLoading};
};

export default useGetSubInputLists;
